angular.module("app").factory("stateAliases", function () {

    var aliases = {
        addBlock: "main.pages.add",
        addMedia: "main.media.add",
        allMedias: "main.media.list",
        addPopup: "main.popups.add",
        allPopups: "main.popups.list",
        editPopups: "main.popups.edit",
        addUser: "main.users.add",
        allUsers: "main.users.list",
        editUsers: "main.users.edit",
        addSkin: "main.skins.add",
        allSkins: "main.skins.list",
        editSkins: "main.skins.edit",
        allBanners: "main.pages.list.banners",
        editBlock: "main.pages.edit",
        editDetailed: "main.pages.editDetailed",
        editItem: "main.pages.editItem",
        createItem: "main.pages.createItem",
        blocksAllCategories: "main.pages.list.categories",
        allNews: "main.pages.list.news",
        allText: "main.pages.list.texts",
        configs: "main.configs",
        styles: "main.styles",
        reset: "main.reset",

        /*
         * casino_general_admin_states
         * */

        addProvider: "main.providers.add",
        allProviders: "main.providers.list",
        editProviders: "main.providers.edit",
        addCategory: "main.categories.add",
        allCategories: "main.categories.list",
        editCategories: "main.categories.edit",
        categoryItemsList: "main.categories.categoryItems",
        categoryItemsAdd: "main.categories.addItem",
        categoryItemsAddEdit: "main.categories.editItem",
        addGame: "main.games.add",
        allGames: "main.games.list",
        editGames: "main.games.edit",
        switchSkins: "main.games.switchSkins",
        allCasinoGames: "main.casinoGames.list",
        editCasinoGames: "main.casinoGames.edit",



        hiddenGamesGroup: "main.hiddenGames"




    };

    function setStates (statesAliases, cd) {
        var i = 0;

        while (statesAliases[i]) {
            angular.isDefined(aliases[statesAliases[i]]) && cd(aliases[statesAliases[i]]);
            i++;
        }
    }

    return {
        setStates: setStates,
        getSiteMapArray: function () {
            return function () {
                var siteMap = [];
                Object.keys(aliases).forEach(function (value) {
                    siteMap.push(aliases[value])
                });
                return siteMap
            }()
        }
    }
});